import React from 'react'

import { Dialog, Button, Typography } from '@hubii/ds-hubii'
import { IconClose } from '@hubii/icons'

type Props = {
  open: boolean
  onDismiss: () => void
}

const NotificationDialog: React.FC<Props> = ({ open, onDismiss }) => {
  return (
    <Dialog isOpen={open} dataTestId='' onClose={onDismiss} size='extraSmall'>
      <div className='flex items-center justify-center p-4'>
        <Button
          size='small'
          variant='text'
          color='neutral'
          StartIcon={IconClose}
          onClick={() => onDismiss()}
          dataTestId='button-close-dialog-notifications'
          className='absolute top-4 right-4'
        />
        <div className='flex flex-col items-center justify-center pt-1 gap-2'>
          <Typography variant='subtitle1' color='textPrimary'>
            Ative as <span className='text-secondary-500'>notificações sonoras</span>
          </Typography>

          <Button
            color='secondary'
            onClick={onDismiss}
            className='w-28'
            dataTestId='button-activate-dialog-notifications'>
            Ativar
          </Button>
        </div>
      </div>
    </Dialog>
  )
}

export default NotificationDialog
